import React, { useEffect, useState } from "react";
import Select from "react-select"
import { toast } from "react-toastify";
import Handler from "../../Helpers/Components/Handler";
import { reloadWindowToPath } from "../../Helpers/Utils";
import Compressor from 'compressorjs';
import { useNavigate, useParams } from "react-router-dom";

const Add = () => {
    const [loading, setLoading] = useState(false)
    const [carDetails, setCarDetails] = useState({})
    const { id } = useParams()
    const regNoValidation = new RegExp('^[a-zA-Z]{2}[0-9]{2}[A-Za-z]{0,2}[0-9]{4}$');
    const validName = new RegExp('^[A-Za-z\\s]*$');
    const navigate = useNavigate()
    const options = [
        { value: "Airtel Payments Bank", label: "Airtel Payments Bank" },
        { value: "AU Small Finance Bank", label: "AU Small Finance Bank" },
        { value: "Axis Bank Ltd", label: "Axis Bank Ltd" },
        { value: "IHMCL Bank", label: "IHMCL Bank" },
        { value: "Bandhan Bank", label: "Bandhan Bank" },
        { value: "Bank of Baroda", label: "Bank of Baroda" },
        { value: "Bank of Maharashtra", label: "Bank of Maharashtra" },
        { value: "Bajaj", label: "Bajaj" },
        { value: "Canara Bank", label: "Canara Bank" },
        { value: "Central Bank of India", label: "Central Bank of India" },
        { value: "City Union Bank Ltd", label: "City Union Bank Ltd" },
        { value: "Cosmos Bank", label: "Cosmos Bank" },
        { value: "Dombivli Nagari Sahakari Bank", label: "Dombivli Nagari Sahakari Bank" },
        { value: "Equitas Small Finance Bank", label: "Equitas Small Finance Bank" },
        { value: "Federal Bank", label: "Federal Bank" },
        { value: "FINO Payments Bank", label: "FINO Payments Bank" },
        { value: "HDFC Bank", label: "HDFC Bank" },
        { value: "ICICI Bank", label: "ICICI Bank" },
        { value: "IDBI Bank", label: "IDBI Bank" },
        { value: "IDFC First Bank", label: "IDFC First Bank" },
        { value: "Indian Bank", label: "Indian Bank" },
        { value: "Indian Overseas Bank", label: "Indian Overseas Bank" },
        { value: "IndusInd Bank Ltd", label: "IndusInd Bank Ltd" },
        { value: "Jammu and Kashmir Bank", label: "Jammu and Kashmir Bank" },
        { value: "Karnataka Bank", label: "Karnataka Bank" },
        { value: "Karur Vysya Bank", label: "Karur Vysya Bank" },
        { value: "Kotak Mahindra Bank", label: "Kotak Mahindra Bank" },
        { value: "Nagpur Nagarik Sahakari Bank", label: "Nagpur Nagarik Sahakari Bank" },
        { value: "PAYTM Payments Bank", label: "PAYTM Payments Bank" },
        { value: "Punjab National Bank", label: "Punjab National Bank" },
        { value: "Saraswat Bank", label: "Saraswat Bank" },
        { value: "South Indian Bank", label: "South Indian Bank" },
        { value: "State Bank of India", label: "State Bank of India" },
        { value: "The Jalgaon People Co-op Bank-op_bank", label: "The Jalgaon People Co-op Bank" },
        { value: "Thrissur District Cooperative Bank", label: "Thrissur District Cooperative Bank" },
        { value: "UCO Bank", label: "UCO Bank" },
        { value: "Union Bank of India", label: "Union Bank of India" },
        { value: "Yes Bank Ltd", label: "Yes Bank Ltd" },
        { value: "LivQuik/QuikWallet", label: "LivQuik/QuikWallet" },
        { value: "Punjab & Maharashtra Co-operative Bank", label: "Punjab & Maharashtra Co-operative Bank" }
    ]
    const handleChange = (e) => {
        setCarDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }
    const checkFileSize = (file) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            setCarDetails((prevValue) => ({ ...prevValue, photo: file }))
        }
    };
    const compressImage = (file) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleSubmit = async () => {
        if (!carDetails?.carId) {
            toast.error("Car ID is required");
        } else if (!carDetails?.model) {
            toast.error("Model is required");
        } else if (!carDetails?.color) {
            toast.error("Color is required");
        } else if (!validName.test(carDetails?.color)) {
            toast.error("Invalid Color");
        } else if (!carDetails?.registrationNo) {
            toast.error("Reg No is required");
        } else if (carDetails?.registrationNo?.length < 8) {
            toast.error("Reg No must have atleast 8 Characters")
        } else if (!regNoValidation.test(carDetails?.registrationNo)) {
            toast.error("Invalid Reg Number")
        } else if (!carDetails?.fasTagType) {
            toast.error("Fastag Bank is required");
        } else if (!carDetails?.segment) {
            toast.error("Segment is required");
        } else if (!carDetails?.photo) {
            toast.error("Photo is required")
        } else {
            const formData = new FormData();
            formData?.append("photo", carDetails?.photo)
            formData?.append("carId", carDetails?.carId)
            formData?.append("model", carDetails?.model)
            formData?.append("registrationNo", carDetails?.registrationNo)
            formData?.append("segment", carDetails?.segment)
            formData?.append("color", carDetails?.color)
            formData?.append("fasTagType", carDetails?.fasTagType)
            setLoading(true)
            const response = await Handler({ method: 'patch', url: `/car/update/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                toast.success(response?.message)
                setTimeout(() => {
                    reloadWindowToPath(`/car/view/${id}`)
                }, 1500);
            } else {
                setLoading(false)
                toast.error(response?.message)
            }
        }
    }
    const handleFileChange = (event) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0]);
        } else {
            toast.error("File not uploaded")
        }
    }
    const getCarDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'get', url: `/car/detail/${id}` })
        if (response?.success) {
            setCarDetails(response?.data)
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    useEffect(() => {
        getCarDetails()
    },[])
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Car Update</h5>
            <div className="layout-card mt-4 p-5">
                <div className="row">
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="carId" className="form-label"> Car ID </label>
                            <input autoComplete="off" disabled={loading} id="carId" type="text" name="carId" value={carDetails?.carId || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="model" className="form-label"> Model </label>
                            <input autoComplete="off" disabled={loading} id="model" type="text" name="model" value={carDetails?.model || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="color" className="form-label"> Colour </label>
                            <input autoComplete="off" disabled={loading} id="color" type="text" name="color" value={carDetails?.color || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="registrationNo" className="form-label"> Reg No </label>
                            <input autoComplete="off" disabled={loading} id="registrationNo" type="text" name="registrationNo" value={carDetails?.registrationNo || ""} onChange={handleChange} className="form-control input-theme text-uppercase" />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="fasTagType" className="form-label"> Fastag Bank </label>
                            <Select
                                value={carDetails?.fasTagType ? { label: carDetails?.fasTagType, value: carDetails?.fasTagType } : ""}
                                onChange={(option) => {
                                    setCarDetails((prevState) => ({ ...prevState, fasTagType: option?.value }))
                                }}
                                isDisabled={loading}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                        boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                        "&:hover": {
                                            borderColor: "#f16436"
                                        }
                                    }),
                                    option: (style, state) => ({
                                        ...style,
                                        backgroundColor: state.isSelected
                                            ? "#f16436"
                                            : (state.isFocused || state.isActive)
                                                ? "#f164361a"
                                                : "white",
                                        color: state.isSelected ? "white" : "black"
                                    })
                                }}
                                options={options}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="segment" className="form-label"> Segment </label>
                            <Select
                                value={carDetails?.segment ? { label: carDetails?.segment, value: carDetails?.segment } : ""}
                                onChange={(option) => {
                                    setCarDetails((prevState) => ({ ...prevState, segment: option?.value }))
                                }}
                                isDisabled={loading}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                        boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                        "&:hover": {
                                            borderColor: "#f16436"
                                        }
                                    }),
                                    option: (style, state) => ({
                                        ...style,
                                        backgroundColor: state.isSelected
                                            ? "#f16436"
                                            : (state.isFocused || state.isActive)
                                                ? "#f164361a"
                                                : "white",
                                        color: state.isSelected ? "white" : "black"
                                    })
                                }}
                                options={[
                                    { value: 'SUV', label: 'SUV' },
                                    { value: 'Mini SUV', label: 'Mini SUV' },
                                    { value: 'Hatchback', label: 'Hatchback' },
                                    { value: 'Comfy Hatchback', label: 'Comfy Hatchback' },
                                    { value: 'Sedan', label: 'Sedan' },
                                    { value: 'Auto Cars', label: 'Auto Cars' },
                                    { value: 'Small Cars', label: 'Small Cars' }
                                ]}
                            />
                        </div>
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-6 col-xl-3">
                        <div className="mb-3">
                            <label htmlFor="photo" className="form-label"> Photo </label>
                            <input autoComplete="off" disabled={loading} id="photo" type="file" accept="image/*" name="photo" onChange={handleFileChange} className="form-control input-theme text-uppercase" />
                        </div>
                    </div>
                </div>
                <div className="text-center mt-4"><button className="btn btn-theme" disabled={loading} onClick={handleSubmit}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}</button></div>
            </div>
        </React.Fragment>
    )
}

export default Add;